import {
  ShiftsResponse as Response,
  ShiftData,
  ShiftUpdateParams,
  convertScheduleChangeToShiftData,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import scheduleKeys from 'schedule/queries/shared/keys'
import { useRecentStoresContext } from 'stores/context'
import keys from './shared/keys'

type Variables = ShiftUpdateParams

export function useAddShift() {
  const { server } = useServer()
  const client = useQueryClient()
  const { activeStoreId } = useRecentStoresContext()

  return useMutation({
    mutationFn: addShift,
    onSuccess: async _ => {
      client.invalidateQueries({ queryKey: keys.all }).catch(e => null)
      client.invalidateQueries({ queryKey: scheduleKeys.all }).catch(e => null)
    },
  })

  async function addShift(updateParams: Variables): Promise<ShiftData> {
    const response = await server.post<Response.ScheduleChange>(
      '/v2/schedule/changes',
      {
        date: updateParams.date,
        start_time: updateParams.startTime,
        end_time: updateParams.endTime,
        initiator_note: updateParams.reason,
        store_id: activeStoreId,
        position_id: updateParams.position?.id,
        type: 'FILL',
        copies: updateParams.copies,
        split_shift: updateParams.splitShift,
        user_id: updateParams.userId,
      }
    )

    return convertScheduleChangeToShiftData(response)
  }
}
